import http from '../Http';
import { useContext, useState } from 'react';
import utils from '../utils';
import { Modal, Button, Input, Form, Upload, Radio } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import config from '../Config';
import { useTranslation } from 'react-i18next';

function DeviceIssueSolutionAdd(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const { show, IssueID, onClose } = props;

    const [form] = Form.useForm();

    const [solutionContent, setSolutionContent] = useState("");
    const [disabled, setDisabled] = useState(false);

    const handleCancle = () => {
        form.resetFields();
        setDisabled(false);
        onClose(null);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => { return null });

        if (ps === null) {
            return;
        }

        const rawContent = ps.Content;
        ps.IssueID = IssueID;
        ps.Content = rawContent ? encodeURIComponent(rawContent) : "";
        ps.Solved = ps.Solved;
        ps.Solver = ps.Solver ?? "";
        ps.Recorder = ps.Recorder || "";
        ps.SolveImage = [];
        ps.SolvePicture && ps.SolvePicture.fileList && ps.SolvePicture.fileList.forEach(v => {
            ps.SolveImage.push(v.response && v.response.code == 200 ? v.response.data[v.name] : '');
        })
        ps.SolveImage = ps.SolveImage.join(',');

        const resp = await http.post("after-sale/device/issue/solution/add", ps).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("add error") });
                return
            }

            setTip({ open: true, severity: 'success', msg: t('add success') });

            ps.Content = rawContent; // 还原原始内容
            ps.ID = resp.data.ID;
            ps.CreateTime = resp.data.CreateTime;
            onClose(ps);
            form.resetFields();

        } catch (e) {
            setTip({ open: true, severity: "error", msg: t("add error") });
        }
    }

    return (<Modal
        title={t("Add Solution")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={500}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button
                key="Clear"
                shape="round"
                onClick={() => {
                    form.resetFields();
                }}
                disabled={disabled}
            >{t("Clear")}</Button>,
            <Button key="Cancel" shape="round" onClick={handleCancle} disabled={disabled}>{t("Cancel")}</Button>,
            <Button key="Submit" shape="round" type="primary" onClick={handleSubmit} disabled={disabled}>{t("Submit")}</Button>
        ]}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 25 }}
            form={form}
            initialValues={{
                Enabled: true,
            }}
        >
            <Form.Item
                name="Content"
                label={t("Solution")}
                rules={[{ required: true }]}
            >
                <Input.TextArea
                    rows={4}
                    maxLength={500}
                    showCount={true}
                    value={solutionContent}
                    placeholder={t("Enter your solution")}
                    onChange={(e) => { setSolutionContent(e.target.value) }}
                />
            </Form.Item>
            <Form.Item
                name="Solved"
                label={t("Solved")}
                rules={[{ required: true }]}
            >
                <Radio.Group>
                    <Radio value={1}>{t("Yes")}</Radio>
                    <Radio value={0}>{t("No")}</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item
                name="Solver"
                label={t("Solver")}
            >
                <Input placeholder={t("Solver Name")} style={{ borderRadius: '5px' }} />
            </Form.Item>
            <Form.Item
                name="Recorder"
                label={t("Recorder")}
            >
                <Input placeholder={t("Recorder Name")} style={{ borderRadius: '5px' }} />
            </Form.Item>
            <Form.Item
                name="SolvePicture"
                label={t("Image")}
            >
                <Upload
                    name="SolvePicture"
                    listType="picture"
                    accept=".png,.jpg,jpeg"
                    action={config.apiUrl + "after-sale/picture/upload/do"}
                    headers={{ 'Token': http.token }}
                    multiple={true}
                    beforeUpload={() => {
                        setDisabled(true);
                    }}
                    onChange={(info) => {
                        if (info && info.file && info.file.status === 'done') {
                            setDisabled(false);
                        }
                    }}
                >
                    <Button icon={<UploadOutlined />}>{t("Choose Images")}</Button>
                </Upload>
            </Form.Item>
        </Form>
    </Modal>);
}

export default DeviceIssueSolutionAdd;